import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { messages } from '@databases/intl/messages';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

import AbstractLink from './AbstractLink';

const StyledErrorText = styled.p`
  color: ${colors.R400};
`;

export interface BrokenLinkProps {
  message?: string;
}

const BrokenLink: FunctionComponent<BrokenLinkProps> = ({ message }) => {
  const { formatMessage } = useIntl();

  return (
    <AbstractLink iconBefore={<ErrorIcon primaryColor={colors.R400} label="" />}>
      <StyledErrorText>
        {message ?? formatMessage(messages['broken-link.broken-link-text'])}
      </StyledErrorText>
    </AbstractLink>
  );
};

export default BrokenLink;
